import React from 'react'
import i18n from '../../../../../../../lib/i18n'
import { orderBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addSlideImages } from '../../../../../actions';
import { notification } from 'antd';


const limitCount = 150;

function UploadSliderImg({countImgs = 0}) {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch()
  const slider = useSelector(state => state.slider.slider)
  const onChange = async (e) => {
    try {
      let myArray = Array.from(e.target.files).map((item, index) => {
        if(!item.type.startsWith('image/')){
          throw new Error('Only images are allowed');
        }
        return {
          item, 
          name_sort: isNaN(parseInt(item.name.replace(/\D+/g,""))) ? index : parseInt(item.name.replace(/\D+/g,"")) 
        }
      });
      myArray = orderBy(myArray, ['name_sort'], ['asc']);

      if(countImgs + myArray.length > limitCount){
        api.error({
          message: i18n('sl_slide_img_title_count'),
          description: i18n('sl_slide_img_msg_count'),
        })
        return;
      }
      await dispatch(addSlideImages(myArray, slider.id));
    } catch (error) {
      api.error({
        message: i18n('sl_slide_img_title'),
        description: i18n('sl_slide_img_msg'),
      })
    }
  }

  return (
    <label>
      {contextHolder}
      {i18n('sl_add_slide_img')}
      {countImgs < limitCount && <input style={{display: 'none'}} multiple type='file' accept='image/*' onChange={onChange}  />}
    </label>
  )
}

export default UploadSliderImg